import React from 'react';
import classNames from 'classnames';
var SelectMultipleOption = function (props) {
    var option = props.option, selected = props.selected, _optionHandler = props._optionHandler, multilineOptions = props.multilineOptions;
    var _inputName = classNames('clyde-select-multiple-option-input', {
        'clyde-select-multiple-option-input--disabled': option.disabled,
        'clyde-select-multiple-option-input--selected': selected,
    });
    var _optionName = classNames('clyde-select-multiple-option', {
        'clyde-select-multiple-option--disabled': option.disabled,
    });
    var _multilineName = classNames({
        'clyde-select-option-text--multiline': multilineOptions,
        'clyde-select-option-text--single-line': !multilineOptions,
    });
    return (React.createElement("div", { "aria-selected": selected, className: _optionName, onMouseUp: function (e) { e.target.blur(); }, onClick: function (e) { _optionHandler(e, option); }, onKeyUp: function (e) { _optionHandler(e, option); }, role: 'option', "data-test": "selectOption-".concat(option.text), tabIndex: 0 },
        React.createElement("div", { className: _inputName }),
        React.createElement("span", { className: _multilineName }, option.text)));
};
export default SelectMultipleOption;
